(() => {
  const initProduct = (root) => {
    if (!root || root.dataset.llxReady === 'true') return;
    root.dataset.llxReady = 'true';

    const panes = Array.from(root.querySelectorAll('[data-llx-media]'));
    const thumbs = Array.from(root.querySelectorAll('[data-llx-media-target]'));
    const counter = root.querySelector('[data-llx-counter-current]');

    const pauseInactiveMedia = (pane) => {
      pane.querySelectorAll('video').forEach((video) => {
        try { video.pause(); } catch (e) {}
      });
    };

    const setActiveMedia = (id, shouldScrollThumb = true) => {
      if (!id || !panes.length) return;
      let matched = false;

      panes.forEach((pane) => {
        const active = String(pane.dataset.llxMedia) === String(id);
        pane.hidden = !active;
        pane.classList.toggle('is-active', active);
        if (active) matched = true;
        else pauseInactiveMedia(pane);
      });

      if (!matched) return;

      thumbs.forEach((thumb) => {
        const active = String(thumb.dataset.llxMediaTarget) === String(id);
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-current', active ? 'true' : 'false');
        if (active) {
          if (counter) counter.textContent = thumb.dataset.llxIndex || '1';
          if (shouldScrollThumb) {
            try { thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' }); } catch (e) {}
          }
        }
      });
    };

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => setActiveMedia(thumb.dataset.llxMediaTarget, false));
    });

    const currentIndex = () => {
      const active = thumbs.findIndex((thumb) => thumb.classList.contains('is-active'));
      return active >= 0 ? active : 0;
    };

    const stepMedia = (direction) => {
      if (thumbs.length < 2) return;
      const index = (currentIndex() + direction + thumbs.length) % thumbs.length;
      setActiveMedia(thumbs[index].dataset.llxMediaTarget);
    };

    root.querySelector('[data-llx-prev]')?.addEventListener('click', () => stepMedia(-1));
    root.querySelector('[data-llx-next]')?.addEventListener('click', () => stepMedia(1));

    const stage = root.querySelector('.llx-pdp__stage');
    if (stage) {
      let touchStartX = null;
      stage.addEventListener('touchstart', (event) => {
        touchStartX = event.changedTouches?.[0]?.clientX ?? null;
      }, { passive: true });
      stage.addEventListener('touchend', (event) => {
        if (touchStartX === null) return;
        const endX = event.changedTouches?.[0]?.clientX ?? touchStartX;
        const delta = endX - touchStartX;
        if (Math.abs(delta) > 55) stepMedia(delta > 0 ? -1 : 1);
        touchStartX = null;
      }, { passive: true });
    }

    const variantSelect = root.querySelector('[data-llx-variant-select]');
    const price = root.querySelector('[data-llx-price]');
    const compare = root.querySelector('[data-llx-compare]');
    const availability = root.querySelector('[data-llx-availability]');
    const availabilityText = root.querySelector('[data-llx-availability-text]');
    const addButton = root.querySelector('[data-llx-add]');
    const addText = root.querySelector('[data-llx-add-text]');

    const updateVariant = () => {
      if (!variantSelect) return;
      const option = variantSelect.options[variantSelect.selectedIndex];
      if (!option) return;

      const available = option.dataset.available === 'true';
      const onSale = option.dataset.onSale === 'true';
      if (price && option.dataset.price) price.textContent = option.dataset.price;
      if (compare) {
        compare.textContent = option.dataset.compare || '';
        compare.hidden = !onSale;
      }
      if (availability) availability.classList.toggle('is-available', available);
      if (availabilityText) availabilityText.textContent = available ? 'Available to order' : 'Currently unavailable';
      if (addButton) addButton.disabled = !available;
      if (addText) addText.textContent = available ? 'Add to cart' : 'Sold out';
      if (option.dataset.mediaId) setActiveMedia(option.dataset.mediaId);
    };

    variantSelect?.addEventListener('change', updateVariant);

    const qtyInput = root.querySelector('[data-llx-qty-input]');
    root.querySelector('[data-llx-qty-minus]')?.addEventListener('click', () => {
      if (!qtyInput) return;
      const value = Number.parseInt(qtyInput.value || '1', 10);
      qtyInput.value = String(Math.max(1, value - 1));
    });
    root.querySelector('[data-llx-qty-plus]')?.addEventListener('click', () => {
      if (!qtyInput) return;
      const value = Number.parseInt(qtyInput.value || '1', 10);
      qtyInput.value = String(Math.max(1, value + 1));
    });
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-llx-product]').forEach(initProduct);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
